import React, { useRef } from "react";
import Logo from "../../assets/img/logo.png";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Collapse from "bootstrap/js/dist/collapse";

export default function NavBar({ about, services, cta }) {
  const navbarRef = useRef(null);

  const closeMenu = () => {
    if (navbarRef.current) {
      const bsCollapse =
        Collapse.getInstance(navbarRef.current) ||
        new Collapse(navbarRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{ background: "#faf7f5" }}
      >
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img src={Logo} alt="LOGO" width={"100px"} />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarSupportedContent"
            ref={navbarRef}
          >
            <div className="d-flex">
              <div>
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "active nav-link" : "nav-link"
                      }
                      to="/"
                      onClick={closeMenu}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "active nav-link" : "nav-link"
                      }
                      to="/about"
                      onClick={closeMenu}
                    >
                      {about}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "active nav-link" : "nav-link"
                      }
                      to="/services"
                      onClick={closeMenu}
                    >
                      {services}
                    </NavLink>
                  </li>
                  <li className="nav-item cta desk-hide">
                    <NavLink
                      to="https://wa.me/917022851682/"
                      target="_blank"
                      className="nav-link"
                      onClick={closeMenu}
                    >
                      {cta}
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mob-hide">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item cta">
                <NavLink
                  to="https://wa.me/917022851682/"
                  target="_blank"
                  className="nav-link"
                >
                  {cta}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

NavBar.propTypes = {
  about: PropTypes.string.isRequired,
  services: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
};
